import React, { useState, useEffect, useCallback } from 'react';
import styled, {keyframes} from 'styled-components';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import IP_URL from '../connect';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchIcon from '@mui/icons-material/Search';

const Main = styled.div``;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  align-items: center;
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
`;


const TableContainer = styled.div`
  margin: 20px;
  margin-bottom: 50px;
  margin-top: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 15px;
  width: 95%;
  overflow-x: auto;
  background-color: #f5faff;
  transition: all 0.3s ease;
`;


const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

const LoadingSpinner = styled.div`
  font-size: 20px;
  color: #00bcd4;
  margin: 20px;
`;


const Input = styled.input`
  padding: 8px;
  margin: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  outline: none;
  transition: border 0.2s ease;

  &:focus {
    border-color: #1976d2;
  }
    @media(max-width: 600px) {
      width:80%;
      margin:3px;
      padding:4px;
    }
`;
const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  input {
    width: 150px;
    padding: 8px 8px 8px 30px; // padding-left for icon
    border-radius: 5px;
    border: 1px solid #ccc;
    outline: none;
    transition: border 0.2s ease;

    &:focus {
      border-color: #1976d2;
    }

    @media (max-width: 600px) {
      width: 100%;
      font-size: 12px;
      padding: 8px 8px 8px 22px;
    }
  }

  svg {
    position: absolute;
    left: 8px;
    color: #999;

    @media (max-width: 600px) {
      left: 4px;
    }
  }
`;

const ButtonSection = styled.div`
display: flex;

button{
 padding:4px;
 margin: 4px;
  background-color: #1976d2;
    color: white;
    font-weight: bold;
    border-radius:4px;
    border: none;
    box-shadow: 2px 2px 2px rgba(0,0,0,0.1);
}

`


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.4s ease;
`;

const ModalTitle = styled.h3`
  margin-bottom: 20px;
  text-align: center;
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  background: ${({ cancel }) => (cancel ? "#6c757d" : "#007bff")};
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  margin-top: ${({ cancel }) => (cancel ? "10px" : "0")};
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: ${({ cancel }) => (cancel ? "#5a6268" : "#0056b3")};
  }
`;

const ModalInput = styled.input`
 padding: 12px;
 border-radius: 4px;
 width: 94%;
 margin-bottom: 12px;
`

const MeterReport = () => {
  const [meterData, setMeterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector(selectUser);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchMeterId, setSearchMeterId] = useState("");
  const [searchSerialNumber, setSearchSerialNumber] = useState("");
  const [searchOrganization, setSearchOrganization] = useState("");
  const [searchMeterName, setSearchMeterName] = useState("");
  const [searchMSISDN,setSearchMSISDN]  = useState('');
  const [showModal, setShowModal] = useState(false);
  const [MSISDN, setMSISDN] = useState('');
  const [selectedMeterId, setSelectedMeterId ] = useState(null);
  const navigate = useNavigate();

  //fetch Meter Data
  const fetchCurrentData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${IP_URL}/meter/all-meter-data`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error('Network response was not okay');

      const data = await response.json();
      setMeterData(data);
      console.log("data", data)

      if (data.length === 0) toast.info('No meter data available.');
    } catch (error) {
      toast.error('Failed to fetch meter data. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchCurrentData();
  }, [fetchCurrentData]);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  const filteredData = meterData.filter((meter) => {
    return (
      (!searchMeterId || meter.meterId?.includes(searchMeterId)) &&
      (!searchSerialNumber || meter.serialNumber?.includes(searchSerialNumber)) &&
      (!searchOrganization || meter.userName?.toLowerCase().includes(searchOrganization.toLowerCase())) &&
      (!searchMeterName || meter.meterName?.toLowerCase().includes(searchMeterName.toLowerCase())) &&
      (!searchMSISDN || meter.MSISDN?.includes(searchMSISDN))
    );
  });

  const navigateToAdminMeterDetails = (imei) => {
    navigate(`/admin-meter-details/${imei}`);
  };

  //add MSISDN
const handleAddMSISDN = async () => {
  if (!MSISDN) {
    toast.warning('Please enter a valid MSISDN');
    return;
  }

    setLoading(true);

  try {
    const response = await fetch(`${IP_URL}/fetchMeter/add-msisdn`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        meterId: selectedMeterId,
        MSISDN: MSISDN,
      }),
    });

    if (!response.ok) {
      const errorMsg = `Server error: ${response.status}`;
      toast.error(errorMsg);
      throw new Error(errorMsg);
    }

    const result = await response.json();
    toast.success('MSISDN added successfully! 🎉');

    // Optionally refresh your table
    await fetchCurrentData?.();

    // Reset and close modal
    setShowModal(false);
    setMSISDN('');
    setSelectedMeterId(null);
  } catch (error) {
    console.error('Error adding MSISDN:', error);
    toast.error('Failed to add MSISDN. Please try again.');
  } finally {
    setLoading(false);
  }
};


  return (
    <Main>
      <Navbar showMenuButton={true} toggleSidebar={toggleSidebar} />
      <Content>
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
<ButtonSection>
  <button onClick={() => navigate('/admin-add-meter')}>Add Meter</button>
</ButtonSection>

 {/* msisdn Modal */}
       <ModalOverlay show={showModal}>
  <ModalContent>
    <ModalTitle>Add MSISDN</ModalTitle>

    <ModalInput
      placeholder='Add MSISDN'
      value={MSISDN}
      onChange={(e) => setMSISDN(e.target.value)}
    />

    <ActionButton onClick={handleAddMSISDN} disabled={loading}>
  {loading ? 'Saving...' : 'Save'}
</ActionButton>


    <ActionButton cancel onClick={() => setShowModal(false)}>
      Cancel
    </ActionButton>
  </ModalContent>
</ModalOverlay>


        <TableContainer>
          {loading && <LoadingSpinner>Loading meters...</LoadingSpinner>}

          {!loading && (
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th><InputWrapper><SearchIcon/><Input type="text" placeholder="Serial" value={searchSerialNumber} onChange={e => setSearchSerialNumber(e.target.value)} /></InputWrapper></th>
                  <th ><InputWrapper><SearchIcon/><Input type="text" placeholder="Meter ID" value={searchMeterId} onChange={e => setSearchMeterId(e.target.value)} /></InputWrapper></th>
                  <th><InputWrapper><SearchIcon/><Input type="text" placeholder="Org" value={searchOrganization} onChange={e => setSearchOrganization(e.target.value)} /></InputWrapper></th>
                  <th><InputWrapper><SearchIcon/><Input type="text" placeholder="Meter Name" value={searchMeterName} onChange={e => setSearchMeterName(e.target.value)} /></InputWrapper></th>
                  <th><InputWrapper><SearchIcon/><Input type="text" placeholder="MSISDN" value={searchMSISDN} onChange={e => setSearchMSISDN(e.target.value)}/></InputWrapper></th>
                  <th>Meter Type</th>
                  <th>User</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? filteredData.map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.serialNumber}</td>
                    <td  style={{cursor:"pointer"}} onClick={() => navigateToAdminMeterDetails(data.imei || data.meterId)}>{data.meterId}</td>
                    <td>{data.organizationUsername}</td>
                    <td>{data.meterName}</td>
                   <td onClick={() => {
    if (!data.MSISDN) {
       setSelectedMeterId(data.meterId); 
      setShowModal(true);
    }
  }}
style={{ cursor: 'pointer', color: !data.MSISDN ? 'red' : 'inherit' }}

>
 {data.MSISDN || 'Add MSISDN'}
</td>

                    <td>{data.meterSize}</td>
                    <td>{data.assignedUserPhoneNumber || 'No User'}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="7">No meters found.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </TableContainer>
      </Content>
      <Footer />
   
    </Main>
  );
};

export default MeterReport;
